import React, {Component} from 'react';
import Card from 'react-bootstrap/Card';
import {Table} from 'react-bootstrap';
import Button from 'react-bootstrap/Button';
import Modal from 'react-bootstrap/Modal';
import Form from 'react-bootstrap/Form';
import $ from 'jquery';
// import 'datatables.net';
// import 'datatables.net-responsive';
// import 'datatables.net-dt/css/jquery.dataTables.min.css';
// import 'datatables.net-buttons/js/dataTables.buttons.min';
// import 'datatables.net-buttons-dt/css/buttons.dataTables.css';
// import 'datatables.net-buttons/js/buttons.html5.min';
import {toast} from 'react-toastify';
import {
  deleteEmployee,
  addEmployee,
  searchEmployee,
  fetchEmployees
} from '../../../services/apifp';

window.JSZip = require('jzip');

const tableId = `#${1}`;

const columns = [
  {
    title: '#',
    data: '_id'
  },
  {
    title: 'รหัสพนักงาน',
    data: 'ID_EMP'
  },
  {
    title: 'ชื่อ-สกุล',
    data: 'NAME'
  },
  {
    title: 'ตำเเหน่ง',
    data: 'POSITION'
  },
  {
    title: 'บริษัท',
    data: 'COMPANY'
  },
  {
    title: 'DELETE',
    data: 'ID_EMP',
    render: function (data, type, row) {
      if (type === 'display') {
        return `<button class="btn btn-danger btn-sm delete-btn" data-id="${data}">DELETE</button>`;
      }
      return data;
    }
  }
];

//  ✅ ฟังก์ชันโหลดข้อมูลใหม่ให้ DataTable
// function reloadTableData(items) {
//   if (!$.fn.DataTable.isDataTable(tableId)) {
//     console.warn('⚠️ DataTable ยังไม่ได้ถูกสร้าง');
//     return;
//   }

//   const table = $(tableId).DataTable();
//   const currentPage = table.page(); // ✅ บันทึกหน้าปัจจุบัน

//   table.clear();
//   table.rows.add(items);
//   table.draw(false);
//   table.page(currentPage).draw(false); // ✅ คงค่าหน้าปัจจุบันไว้

//   setTimeout(function () {
//     if (table) {
//       table.columns.adjust();
//     }
//   }, 50);
// }

function reloadTableData(items, page, filter) {
  console.log('reload: ' + items.length);
  console.log('page: ' + page);
  const $table = $(tableId);
  if ($table.length && $.fn.dataTable.isDataTable($table)) {
    const table = $table.DataTable();
    table.clear();

    table.rows.add(items);
    table.draw();
    table.search(filter);
    table.page(page).draw('page');
    
    setTimeout(function () {
      // เช็คว่า table element ยังอยู่ใน DOM ก่อน adjust
      if ($table.length && document.body.contains($table[0])) {
        table.columns.adjust();
      }
    }, 50);
  }
}

class TableAccounting extends Component {
  constructor(props) {
    super(props);

    this.state = {
      searchQuery: '',
      loading: false,
      showModal: false,
      searchResults: []
    };

    this.tableRef = React.createRef();
    this.handleDeleteClick = this.handleDeleteClick.bind(this);
  }

  componentDidMount() {
    if (!$.fn.DataTable.isDataTable(tableId)) {
      this.initTable();
    }
    $(tableId + ' tbody')
      .off('click', '.delete-btn')
      .on('click', '.delete-btn', this.handleDeleteClick);
  }

  shouldComponentUpdate(nextProps) {
    reloadTableData(nextProps.items, nextProps.page2, nextProps.filter2);
    return true;
  }

//   componentDidUpdate(prevProps) {
//     if (JSON.stringify(prevProps.items) !== JSON.stringify(this.props.items)) {
//       reloadTableData(this.props.items);
//     }
//   }

  componentWillUnmount() {
    if ($.fn.DataTable.isDataTable(tableId)) {
      $(tableId).DataTable().destroy(true);
    }
  }

  async loadEmployees() {
    try {
      const employees = await fetchEmployees();
      this.setState({employees});
    } catch (error) {
      console.error('โหลดพนักงานล้มเหลว:', error);
      toast.error('ไม่สามารถโหลดข้อมูลพนักงาน');
    }
  }

  initTable() {
    if ($.fn.DataTable.isDataTable(tableId)) {
      console.warn('DataTable ถูกสร้างไปแล้ว');
      return;
    }

    $(tableId).DataTable({
      data: this.props.items || [],
      dom: 'Bfrtip',
      columns: columns,
      searching: true,
      order: [[0, 'asc']],
      paging: true,
      ordering: true,
      autoWidth: true,
      destroy: true,
      pageLength: 10,
      scrollX: true,
      buttons: [
        'copy',
        {extend: 'csv', title: `data_report_csv_${Date.now()}`},
        {extend: 'excelHtml5', title: `data_report_excel_${Date.now()}`}
      ]
    });

    $(tableId + ' tbody').on('click', '.delete-btn', this.handleDeleteClick);
  }

  handleSearch = async () => {
    const {searchQuery} = this.state;

    if (!searchQuery.trim()) {
      toast.warning('กรุณากรอกคำค้นหาเพื่อเพิ่มสมาชิก');
      return;
    }

    this.setState({loading: true});

    try {
      const data = await searchEmployee(searchQuery);
      if (Array.isArray(data)) {
        this.setState({searchResults: data, showModal: true});
      } else {
        toast.error('ไม่พบข้อมูลพนักงาน');
      }
    } catch (error) {
      toast.error('เกิดข้อผิดพลาดในการค้นหา');
      console.error('Search Error:', error);
    } finally {
      this.setState({loading: false});
    }
  };

  handleKeyDown = (event) => {
    if (event.key === 'Enter') {
      event.preventDefault(); // ✅ ป้องกันฟอร์มรีเฟรช
      this.handleSearch();
    }
  };

  handleAddEmployee = async (id) => {
    try {
      await addEmployee(id);
      toast.success(`เพิ่มพนักงาน ID ${id} สำเร็จ!`);

      // ✅ ปิด Modal ทันที
      this.setState({showModal: false});

      // ✅ โหลดข้อมูลใหม่ให้ DataTable (รักษา page2 และ filter2)
      this.props.reloadEmployees(this.props.page2, this.props.filter2);
    } catch (error) {
      toast.error('เพิ่มพนักงานล้มเหลว');
      console.error('Add Employee Error:', error);
    }
  };

  async handleDeleteClick(event) {
    if (this.state.loadingDelete) return; // ป้องกันการกดซ้ำ

    this.setState({loadingDelete: true});

    const id = $(event.currentTarget).attr('data-id');
    if (!id) {
      console.error('ไม่พบ ID_EMP');
      this.setState({loadingDelete: false});
      return;
    }

    try {
      await deleteEmployee(id);
      toast.success(`ลบพนักงาน ${id} สำเร็จ!`);

      // ✅ โหลดข้อมูลใหม่ให้ DataTable (รักษา page2 และ filter2)
      this.props.reloadEmployees(this.props.page2, this.props.filter2);
    } catch (error) {
      toast.error(`ลบพนักงาน ${id} ล้มเหลว`);
      console.error('Delete Employee Error:', error);
    } finally {
      this.setState({loadingDelete: false});
    }
  }

  render() {
    return (
      <div>
        <Card className="card-warning">
          {!this.props.isAdmin && (
            <div className="overlay dark">
              <span style={{color: 'white', fontSize: 30}}>ADMIN ONLY</span>
            </div>
          )}
          <Card.Header>
            <div className="col-12">
              <div className="row">
                {/* <div className='col-2'>ค้นหาเพื่อเพิ่มสมาชิก</div> */}
                <div className="col-6">
                  <Form.Control
                    type="text"
                    placeholder="ค้นหาเพื่อเพิ่มสมาชิก รหัสพนักงาน, ชื่อ-สกุล"
                    value={this.state.searchQuery}
                    onChange={(e) =>
                      this.setState({searchQuery: e.target.value})
                    }
                    onKeyDown={this.handleKeyDown} // ✅ รองรับ Enter
                  />
                </div>
                <div className="col-4">
                  <Button
                    variant="primary"
                    onClick={this.handleSearch}
                    disabled={this.state.loading}
                  >
                    {this.state.loading ? 'กำลังค้นหา...' : 'ค้นหา'}
                  </Button>
                </div>
              </div>
            </div>
          </Card.Header>
          <Card.Body>
            <table
              ref={this.tableRef}
              className="display nowrap example"
              id={1}
              style={{width: '100%'}}
            />
          </Card.Body>
        </Card>

        <Modal
          show={this.state.showModal}
          onHide={() => this.setState({showModal: false})}
          size="lg"
          // centered // ทำให้ Modal อยู่ตรงกลางจอ
          className="responsive-modal"
        >
          <Modal.Header closeButton>
            <Modal.Title>ผลการค้นหา</Modal.Title>
          </Modal.Header>
          <Modal.Body>
            <div
              className="row"
              style={{
                overflowX: 'auto', // ✅ ใช้ auto แทน scroll เพื่อให้ขยายเมื่อจำเป็น
                overflowY: 'hidden',
                width: '100%' // ✅ ใช้ 100% เพื่อให้ตอบสนองกับหน้าจอ
              }}
            >
              <div
                className="col-12"
                style={{
                  minWidth: '1000px', // ✅ ป้องกันตารางแตก
                  maxWidth: '100%' // ✅ ให้ขยายตามจอ
                  // borderStyle: 'solid',
                }}
              >
                <div className="table-responsive">
                  {' '}
                  {/* ✅ ทำให้ตารางเลื่อนใน Modal ได้ */}
                  <Table striped bordered hover className="w-100">
                    <thead>
                      <tr>
                        <th>เพิ่ม</th>
                        <th>รหัสพนังงาน</th>
                        <th>ชื่อ-สกุล</th>
                        <th>บริษัท</th>
                        <th>ตำแหน่ง</th>
                      </tr>
                    </thead>
                    <tbody>
                      {this.state.searchResults.length > 0 ? (
                        this.state.searchResults.map((emp) => (
                          <tr key={emp.ID_Emp}>
                            <td style={{width: 50}}>
                              <Button
                                variant="success"
                                size="sm"
                                onClick={() =>
                                  this.handleAddEmployee(emp.ID_Emp)
                                }
                              >
                                เพิ่ม
                              </Button>
                            </td>
                            <td style={{width: 50}}>{emp.ID_Emp}</td>
                            <td style={{width: 100}}>{emp.EmpName}</td>
                            <td style={{width: 150}}>{emp.CompanyName}</td>
                            <td style={{width: 120}}>{emp.Position}</td>
                          </tr>
                        ))
                      ) : (
                        <tr>
                          <td colSpan="5" className="text-center">
                            ❌ไม่พบข้อมูล
                          </td>
                        </tr>
                      )}
                    </tbody>
                  </Table>
                </div>
              </div>
            </div>
          </Modal.Body>
        </Modal>
      </div>
    );
  }
}
export default TableAccounting;
